import { Button, Grid } from '@mui/material'
import React from 'react'

import SubCard from 'ui-component/cards/SubCard'
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import AgentTable from './Components/AddVendor/AgentTable';
import InputLabel from '@mui/material/InputLabel';
import { useState } from 'react';
import AddForm from './Components/AddVendor/AddForm';
// import { useEffect } from 'react';
// import { Getstates } from 'API/DsOnboarding/api';
// import {  fetchSubDistrict } from 'API/AgentOnboarding/api';
// import { getAgentList } from 'API/Mapping/api';




const AddVendor = () => {
    // const [status, setStatus] = React.useState(false);
    const [Data,setData]=useState(null)
    const[Add,setAdd]=useState(false)

    const[Selected,setSelected]=useState(false)
    // const [AgentList,setAgentList]=useState(null)

    const handleChange = (name,value) => {
        setData({ ...Data, [name]: value });
    };

    const handleStatusChange=(name,value) => {
        setStatus(value)
    }

   


    return (
        <SubCard title='Add Vendor' sx={{height:'80vh',overflowY:'scroll'}}>

            <Grid container justifyContent='space-between' gap={1} sx={{display:Selected?'none':'flex'}}>
                <Grid item xl={2} md={6} lg={4} sm={12} xs={12}>
                    <Box>
                        <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Vendor Name</InputLabel>
                            <Select
                                labelid="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Vendor Name"
                                onChange={(e)=>handleStatusChange("name",e.target.value)}
                            >
                                <MenuItem value={'unmapped'}>Unmapped Agents</MenuItem>
                                <MenuItem value={'mapped'}>Mapped agents</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                </Grid>
                <Grid item xl={2} md={6} lg={4} sm={12} xs={12}>
                    <Box>
                        <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Company Name</InputLabel>
                            <Select
                                labelid="demo-simple-select-label"
                                id="demo-simple-select"
                                label="State"
                                onChange={(e)=>handleChange('state',e.target.value)}
                            >
                               
                            </Select>
                        </FormControl>
                    </Box>
                </Grid>
                

                <Grid item xl={2} md={6} lg={4} sm={12} xs={12}>
                    <Button variant='contained' color='secondary' onClick={()=>setAdd(true)}>Add Vendor</Button>
                </Grid>
                
            </Grid>
            <Grid container mt={5}>
                <Grid item xl={12} sx={{overflowX:'scroll'}}>
                    {
                        Add?
                        <AddForm setAdd={setAdd}/>
                        :

                        <AgentTable   setSelected={setSelected}/>
                    }
                </Grid>
            </Grid>

        </SubCard>
    )

}


export default AddVendor